import { useTranslation } from "react-i18next";
import { Control, Controller } from "react-hook-form";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import { InputContainer } from "shared/styles/input-container-style";
import { GetExtraWorkAgreementQueryResponse } from "api/generatedApi";
import { ExtraWorkAgreementFormData } from "../hooks/use-input-validation";
import { useExtraWorkAgreementFormatter } from "../../hooks/format";
import { MenuItem, Select, InputLabel, Box } from "@mui/material";
import { Fragment } from "react";

interface Props {
  control: Control<ExtraWorkAgreementFormData>;
  disabled: boolean;
  agreement?: GetExtraWorkAgreementQueryResponse;
}

export const EditExtraWorkAgreementSelectType = (props: Props) => {
  const { t } = useTranslation();
  const { getTypeFormatted, getTypeByAgreementFormatted } = useExtraWorkAgreementFormatter();

  return (
    <InputContainer sx={{ height: props.disabled ? 1 : 100, maxWidth: 250 }}>
      {props.disabled ? (
        <Box display="flex" flexDirection="column" gap={0.6}>
          <Typography variant="caption" sx={{ color: "primary.main" }}>
            {t("dashboard.extraWorkAgreements.create.typeTitle")}
          </Typography>
          <Typography variant="body1">{getTypeByAgreementFormatted(props.agreement)}</Typography>
        </Box>
      ) : (
        <>
          <Typography color="primary.main" variant="caption">
            {t("captions.typeRequired")}
          </Typography>

          <FormControl sx={{ my: 1 }}>
            <InputLabel>{t("dashboard.extraWorkAgreements.create.type.noSelectLabel")}</InputLabel>
            <Select label="extraWorkAgreementType" defaultValue={props.agreement?.extraWorkAgreementType ?? props.control._defaultValues.extraWorkAgreementType ?? "CustomerHours"} {...props.control.register("extraWorkAgreementType")}>
              <MenuItem value={"CustomerHours"}>{getTypeFormatted("CustomerHours")}</MenuItem>
              <MenuItem value={"CompanyHours"}>{getTypeFormatted("CompanyHours")}</MenuItem>
              <MenuItem value={"AgreedPayment"}>{getTypeFormatted("AgreedPayment")}</MenuItem>
              <MenuItem value={"Other"}>{getTypeFormatted("Other")}</MenuItem>
            </Select>
          </FormControl>
        </>
      )}
    </InputContainer>
  );
};
